import Select from 'features/common/components/Select'
import globe from 'assets/globe.svg'
import roIcon from 'assets/romania.svg'
import bgIcon from 'assets/bulgaria.svg'
import {useTranslation} from 'react-i18next'

const CountryOption = ({
    label,
    icon,
    isPlaceholder,
}: {
    label: string
    icon: string
    isPlaceholder?: boolean
}) => {
    return (
        <div
            className={`flex flex-1 items-center gap-7.5 text-xl ${
                isPlaceholder ? 'text-grey-20' : ''
            }`}
        >
            <div className="flex h-[1.875rem] w-[1.875rem]">
                <img src={icon} alt={label} />
            </div>
            <div>{label}</div>
        </div>
    )
}

type CountrySelectProps = {
    chosenValue: string | null
    onChange: (op: string) => void
}

const countryOptions = [
    {
        value: 'ro',
        label: 'ROMANIA',
        icon: roIcon,
    },
    {
        value: 'bg',
        label: 'BULGARIA',
        icon: bgIcon,
    },
] as const
const CountrySelect = ({chosenValue, onChange}: CountrySelectProps) => {
    const {t} = useTranslation()

    const chosenOption = countryOptions.find((op) => op.value === chosenValue)

    return (
        <div className="relative flex flex-1">
            <Select
                value={chosenValue}
                onChange={(value: string) => value && onChange(value)}
            >
                <Select.Button className="h-[3.75rem] rounded-t-[1.875rem] rounded-b-[1.875rem]">
                    {chosenOption ? (
                        <CountryOption
                            label={t(chosenOption.label)}
                            icon={chosenOption.icon}
                        />
                    ) : (
                        <CountryOption
                            label={t('AUTH_COUNTRY_PLACEHOLDER')}
                            icon={globe}
                            isPlaceholder
                        />
                    )}
                </Select.Button>
                <Select.Options className="rounded-b-[1.875rem]">
                    {countryOptions.map((op) =>
                        op.value !== chosenValue ? (
                            <Select.Option
                                className="h-[3.75rem]"
                                key={op.value}
                                value={op.value}
                            >
                                <CountryOption
                                    label={t(op.label)}
                                    icon={op.icon}
                                />
                            </Select.Option>
                        ) : null,
                    )}
                </Select.Options>
            </Select>
        </div>
    )
}

export default CountrySelect
